import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { key: 1 }

import { computed, onMounted, ref } from 'vue'

import { useTripsStore } from '@/store/trips'

import CommonError from '@/components/CommonError.vue'
import DetailsSection from './DetailsSection.vue'
import PriceBreakDownSection from './PriceBreakDownSection.vue'
import CancellationRequestsSection from './CancellationRequestsSection.vue'
import DamageReportsSection from './DamageReportsSection.vue'
import CheckInSection from './CheckInSection.vue'
import CheckOutSection from './CheckOutSection.vue'
import Loader from '@/components/Loader.vue'
import ReviewsSection from './ReviewsSection.vue'
import LogsTab from './LogsTab.vue'
import InsuranceLogs from './InsuranceLogs.vue'
import FinanceSection from './FinanceSection.vue'
import { TripStatus } from '@/models/trip'
import InsurancesSection from './InsurancesSection.vue'
import PortalPaperForTrip from './PortalPaperForTrip.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props

const tripsStore = useTripsStore()

const activeTab = ref('trip-info')

const trip = computed(() => tripsStore.tripsDetails[props.id]?.data)
const error = computed(() => tripsStore.tripsDetails[props.id]?.error)
const isLoading = computed(() => tripsStore.tripsDetails[props.id]?.isLoading)

const getTripDetails = () => {
  tripsStore.getTripDetails(props.id)
}

onMounted(() => {
  if (!isLoading.value) getTripDetails()
})

return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, {
    direction: "vertical",
    class: "container"
  }, {
    default: _withCtx(() => [
      (error.value)
        ? (_openBlock(), _createBlock(CommonError, {
            key: 0,
            errorMessage: error.value,
            onRetryPress: getTripDetails
          }, null, 8, ["errorMessage"]))
        : (!trip.value)
          ? (_openBlock(), _createBlock(Loader, { key: 1 }))
          : (_openBlock(), _createBlock(_component_el_tabs, {
              key: 2,
              modelValue: activeTab.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
              type: "card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: "Trip info",
                  name: "trip-info"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { always: "" }, {
                      default: _withCtx(() => [
                        _createVNode(DetailsSection, { trip: trip.value }, null, 8, ["trip"]),
                        _createVNode(PriceBreakDownSection, { trip: trip.value }, null, 8, ["trip"]),
                        _createVNode(ReviewsSection, { trip: trip.value }, null, 8, ["trip"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "Insurance",
                  name: "insurances",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { always: "" }, {
                      default: _withCtx(() => [
                        (!trip.value.car_profile.opt_out_from_in_app_insurance_service)
                          ? (_openBlock(), _createBlock(InsurancesSection, {
                              key: 0,
                              trip: trip.value
                            }, null, 8, ["trip"]))
                          : (_openBlock(), _createElementBlock("h3", _hoisted_1, _cache[1] || (_cache[1] = [
                              _createTextVNode(" This is a commercially hosted vehicle. "),
                              _createElementVNode("br", null, null, -1),
                              _createTextVNode(" Insurance is to be provided by the Commercial Host and is already included in the rental price. ")
                            ])))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  name: "insurance-logs",
                  label: "Insurance log",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(InsuranceLogs, { trip: trip.value }, null, 8, ["trip"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  name: "check-in",
                  label: "Check-in",
                  disabled: !trip.value.checkIns.length
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { always: "" }, {
                      default: _withCtx(() => [
                        _createVNode(CheckInSection, { trip: trip.value }, null, 8, ["trip"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_tab_pane, {
                  name: "check-out",
                  label: "Check-out",
                  disabled: !trip.value.checkOuts.length
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { always: "" }, {
                      default: _withCtx(() => [
                        _createVNode(CheckOutSection, { trip: trip.value }, null, 8, ["trip"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_tab_pane, {
                  name: "cancellation-requests",
                  label: 
            `Cancellation requests (${trip.value.cancellation_requests.length})`
          ,
                  disabled: 
            !trip.value.cancellation_requests.length ||
              trip.value.status !== _unref(TripStatus).ON_HOLD
          
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { always: "" }, {
                      default: _withCtx(() => [
                        _createVNode(CancellationRequestsSection, { trip: trip.value }, null, 8, ["trip"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["label", "disabled"]),
                _createVNode(_component_el_tab_pane, {
                  name: "damage-reports",
                  label: `Damage reports (${trip.value.damage_reports.length})`,
                  disabled: !trip.value.damage_reports.length
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { always: "" }, {
                      default: _withCtx(() => [
                        _createVNode(DamageReportsSection, { trip: trip.value }, null, 8, ["trip"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["label", "disabled"]),
                _createVNode(_component_el_tab_pane, {
                  name: "trip-logs",
                  label: "Trip logs",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(LogsTab, { trip: trip.value }, null, 8, ["trip"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  name: "finance",
                  label: "Finance"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { always: "" }, {
                      default: _withCtx(() => [
                        _createVNode(FinanceSection, { trip: trip.value }, null, 8, ["trip"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "Portal Paper",
                  name: "portal-paper"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { always: "" }, {
                      default: _withCtx(() => [
                        _createVNode(PortalPaperForTrip, { trip: trip.value }, null, 8, ["trip"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
    ]),
    _: 1
  }))
}
}

})